module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_10-15b8b2123938e8593b85c2fad0204a49.png";